import Resource from '@/api/resources/Resource'

class LaboratoryWeekendDaysServices extends Resource {
    async getAllLaboratoryWeekendDays(laboratoryId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/weekendDays`)
        return response.data
    }
}

export default new LaboratoryWeekendDaysServices()
